module.exports = __webpack_public_path__ + "img/0-115.dae22317.jpg";